import { render, staticRenderFns } from "./PayfastLoader.vue?vue&type=template&id=2c3d95b8&scoped=true"
import script from "./PayfastLoader.vue?vue&type=script&lang=js"
export * from "./PayfastLoader.vue?vue&type=script&lang=js"
import style0 from "./PayfastLoader.vue?vue&type=style&index=0&id=2c3d95b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d95b8",
  null
  
)

export default component.exports